module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_ErrorCircle1_16"],"path":[{"$":{"d":"M8,0a8,8,0,1,0,8,8A8,8,0,0,0,8,0Zm3.71,10.29-1.41,1.41L8,9.41,5.71,11.71,4.29,10.29,6.59,8,4.29,5.71,5.71,4.29,8,6.59l2.29-2.29,1.41,1.41L9.41,8Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_ErrorCircle1_16.svg
// module id = Hjxm
// module chunks = 1